import { useQuery } from '@apollo/client/react';
import { useIsAccessTokenExpired } from 'app/domains/auth/hooks/useIsAccessTokenExpired';
import { useCompanyFeatures } from 'app/domains/companies/features/CompanyFeatures';
import { useDocumentLocked } from 'app/domains/documents';
import { useActiveDocument, useGetCurrentUser, usePleditor } from 'shared/domains/documents';
import { RestrictedEditingMode, ASSISTANT_COMPONENT_NAME, documentFormattingToolbarItems, documentCollaborativeEditingToolbarItems, documentRestrictedToolbarItems, } from 'shared/domains/pleditor@next';
import { AppPleditorAttachmentsDocument } from './AppPleditorAttachments.gql';
import { PleditorError } from '../../components/PleditorError';
import { PleditorLoader } from '../../components/PleditorLoader';
import { RTCPleditor } from '../RTCPleditor';
import { SandboxPleditor } from '../SandboxPleditor';
import { useImportDocumentToCcs } from '../hooks';
import { APP_FREE_TEXT_PLUGINS } from '../plugins';
export function AppFreeTextRTCPleditor() {
    var _a;
    const { locked } = useDocumentLocked();
    const { sandboxMode } = usePleditor();
    const currentUser = useGetCurrentUser();
    const { id } = useActiveDocument();
    const { data, loading: loadingAttachments } = useQuery(AppPleditorAttachmentsDocument, {
        variables: {
            documentId: id,
        },
    });
    const attachments = ((_a = data === null || data === void 0 ? void 0 : data.document) === null || _a === void 0 ? void 0 : _a.attachments) || [];
    const { isAccessTokenExpired } = useIsAccessTokenExpired();
    const { loading: importing, error: importError } = useImportDocumentToCcs();
    const { isFeatureAvailable, loading: loadingFeatures, error: featuresError } = useCompanyFeatures();
    const loading = importing || loadingFeatures || loadingAttachments;
    const error = importError || featuresError;
    const plugins = locked ? [...APP_FREE_TEXT_PLUGINS, RestrictedEditingMode] : APP_FREE_TEXT_PLUGINS;
    if (loading) {
        return <PleditorLoader />;
    }
    if (error) {
        return <PleditorError />;
    }
    const defaultToolbarItems = [...documentFormattingToolbarItems(), ...documentCollaborativeEditingToolbarItems()];
    const restrictedToolbarItems = documentRestrictedToolbarItems();
    const balloonToolbarItems = [
        'bold',
        'italic',
        'underline',
        '|',
        'inlineComment',
        ASSISTANT_COMPONENT_NAME,
        'selectAttachmentWidget',
    ];
    const toolbarItems = locked ? restrictedToolbarItems : defaultToolbarItems;
    const featureAvailability = { suggestions: isFeatureAvailable('EDITOR_SUGGESTIONS') };
    if (sandboxMode) {
        return (<SandboxPleditor attachments={attachments} currentUser={currentUser} toolbarItems={defaultToolbarItems} balloonToolbarItems={balloonToolbarItems} featureAvailability={featureAvailability}/>);
    }
    return (<RTCPleditor editorName="AppFreeTextRTCPleditor" documentType="freetext" attachments={attachments} toolbarItems={toolbarItems} balloonToolbarItems={balloonToolbarItems} currentUser={currentUser} featureAvailability={featureAvailability} isSessionExpired={isAccessTokenExpired} clientPlugins={plugins} locked={locked}/>);
}
